module.exports = __webpack_public_path__ + "static/media/QUIET_HOME.f14b3dca.svg";